// 戴冠獣の突進 (houndLunge) と跳びかかり (houndPounce) に、介錯の突き当て 1028e の滑らかさの作りを持ち込んだ比較版 (2026-10-28)。
//   計画 = docs/research/2026-10-28-smooth-frame-plan-hound-knight-shade.md。位置・傾き・替わり目の溶かしで繋ぎ (手順1)、
//   それで埋まらない形の差 (待機は背が水平・立ち上がりは体が立つ) だけ段の絵を2枚足した (手順3・houndSmooth_rise / houndSmooth_sink)。
//   配布版は絵を1枚ずつ切り替えるだけで、立ち上がる絵へ1コマで替わる (待機→立ち上がりで 113〜119px の飛び)。
//     入り: 待機のまま後ろへ重心を移して少し沈む → 起こす途中の絵 (約8コマ) → 立ち上がり
//     溜め: 立ち上がりの頂点で止めず伸び上がり続け、跳ぶ/走り出す直前に沈みの絵 (約8コマ・前脚を下ろし後ろ脚を縮める)
//     戻り: 腰は一方向へ動かす。突進は頭を下げた絵から起き上がる向きへ、跳びかかりは着地の絵から起き上がる向きへ
//   動物なので剣舞の「構えて止める」型へは寄せない (溜めの間も体を動かし続ける)。
//   秒数・判定・tag は配布版のまま＝描画だけ。開発版の ?houndSmooth=1028 でだけ入る (配布版の既定は old＝今のまま)。
import { BOSS_ATTACK_TIMELINES, type BossAttackTimeline } from './boss_pose_timeline'
import { withDissolves } from './blade_dancer_art'

// attacks.ts の秒数 (溶かしの長さの計算に使う)。
const LUNGE_MS = { telegraph: 900, active: 180, recovery: 620 }
// 跳びかかりの溜めは boss_pose_timeline.ts の特別扱いで 1420ms 物差しに直してある。
const POUNCE_MS = { telegraph: 1420, active: 200, recovery: 1100 }

export const HOUND_LUNGE_SMOOTH_1028: BossAttackTimeline = withDissolves([
  // 待機のまま後ろ脚へ重心を移して沈む
  { phase: 'telegraph', at: 0.0, image: 'idle', hold: true, ease: 'easeIn' },
  { phase: 'telegraph', at: 0.22, image: 'idle', hold: true, offset: { x: -6, y: 4 }, rot: -2, soft: true },
  // 段の絵: 後ろ脚を床に残したまま上体を起こす途中 (約8コマ)
  { phase: 'telegraph', at: 0.26, image: 'houndSmooth_rise', hold: true, tag: 'anticipation', ease: 'easeOut', offset: { x: -6, y: 2 }, rot: 3 },
  { phase: 'telegraph', at: 0.38, image: 'houndSmooth_rise', hold: true, offset: { x: -8 }, soft: true },
  { phase: 'telegraph', at: 0.42, image: 'houndLunge_windup_1007', hold: true, ease: 'easeOut', offset: { x: -8, y: 2 }, rot: 5 },
  { phase: 'telegraph', at: 0.6, image: 'houndLunge_windup_1007', hold: true, ease: 'easeIn', offset: { x: -10, y: -3 } },
  { phase: 'telegraph', at: 0.66, image: 'houndLunge_windup_1007', hold: true, ease: 'easeIn', offset: { x: -6, y: -2 }, rot: 3, soft: true },
  // 下りも起こす途中の絵を通る (立った絵から沈みの絵へ1コマで替えると頭が約500px落ちる・10-28 等速で確かめた)
  { phase: 'telegraph', at: 0.68, image: 'houndSmooth_rise', hold: true, ease: 'easeIn', offset: { x: -4 } },
  { phase: 'telegraph', at: 0.81, image: 'houndSmooth_rise', hold: true, offset: { x: 0, y: 2 }, rot: 4, soft: true },
  // 段の絵: 前脚を下ろして前へ倒れ、後ろ脚を縮める (走り出しの直前・約8コマ)
  { phase: 'telegraph', at: 0.83, image: 'houndSmooth_sink', hold: true, ease: 'easeIn', offset: { x: 2 } },
  { phase: 'telegraph', at: 1.0, image: 'houndSmooth_sink', hold: true, offset: { x: 10, y: 3 }, rot: 2 },
  { phase: 'active', at: 0.0, image: 'houndLunge_precontact', ease: 'easeOut', offset: { x: 10 } },
  { phase: 'active', at: 0.25, image: 'houndLunge_contact', tag: 'contact' },
  // 頭を床まで下げた絵から、起き上がる向きへ (腰は一方向)
  { phase: 'recovery', at: 0.3, image: 'houndLunge_follow', tag: 'followThrough', hold: true, ease: 'easeIn' },
  { phase: 'recovery', at: 0.8, image: 'houndLunge_follow', hold: true, offset: { y: -3 }, rot: -4, soft: true },
  { phase: 'recovery', at: 0.88, image: 'idle', hold: true, ease: 'easeOut', offset: { y: 4 } },
  { phase: 'recovery', at: 1.0, image: 'idle', hold: true },
], LUNGE_MS)

export const HOUND_POUNCE_SMOOTH_1028: BossAttackTimeline = withDissolves([
  { phase: 'telegraph', at: 0, image: 'idle', hold: true, ease: 'easeIn' },
  { phase: 'telegraph', at: 0.06, image: 'idle', hold: true, offset: { x: -6, y: 4 }, rot: -2, soft: true },
  // 段の絵: 突進の入りと同じ「起こす途中」(約8コマ)
  { phase: 'telegraph', at: 0.09, image: 'houndSmooth_rise', hold: true, tag: 'anticipation', ease: 'easeOut', offset: { x: -6, y: 2 }, rot: 3 },
  { phase: 'telegraph', at: 0.17, image: 'houndSmooth_rise', hold: true, offset: { x: -6 }, soft: true },
  { phase: 'telegraph', at: 0.2, image: 'houndPounce_rearup', hold: true, ease: 'easeOut', offset: { x: -6, y: 2 }, rot: 5 },
  // 頂点で止めず、ゆっくり伸び上がり続ける
  { phase: 'telegraph', at: 0.32, image: 'houndPounce_rearup', hold: true, offset: { y: -4 } },
  { phase: 'telegraph', at: 0.58, image: 'houndPounce_rearup', hold: true, ease: 'easeIn', offset: { y: -8 }, rot: 2, soft: true },
  // 下りも起こす途中の絵を通る (突進と同じ理由)
  { phase: 'telegraph', at: 0.6, image: 'houndSmooth_rise', hold: true, ease: 'easeIn', offset: { y: -4 } },
  { phase: 'telegraph', at: 0.67, image: 'houndSmooth_rise', hold: true, offset: { x: 2, y: 2 }, rot: 4, soft: true },
  // 段の絵: 跳ぶ直前に前脚を下ろして沈み、後ろ脚を溜める (約8コマ)
  { phase: 'telegraph', at: 0.68, image: 'houndSmooth_sink', hold: true, ease: 'easeIn', offset: { x: 2 } },
  { phase: 'telegraph', at: 1100 / 1420, image: 'houndSmooth_sink', hold: true, offset: { x: 6, y: 4 } },
  { phase: 'telegraph', at: 1100 / 1420 + 0.001, image: 'houndPounce_leap', hold: true, offset: { y: 0 }, ease: 'easeOut', rot: 4 },
  { phase: 'telegraph', at: 1260 / 1420, image: 'houndPounce_leap', hold: true, offset: { y: -70 }, ease: 'easeIn' },
  { phase: 'active', at: 0, image: 'houndPounce_land', hold: true, tag: 'contact', offset: { y: 0 }, ease: 'step' },
  // 着地の重さを保ってから、起き上がる向きへ
  { phase: 'recovery', at: 0, image: 'houndPounce_land', hold: true, tag: 'followThrough', ease: 'easeIn' },
  { phase: 'recovery', at: 0.56, image: 'houndPounce_land', hold: true, offset: { y: -3 }, rot: -3, soft: true },
  { phase: 'recovery', at: 0.6, image: 'idle', hold: true, ease: 'easeOut', offset: { y: 4 } },
  { phase: 'recovery', at: 0.8, image: 'idle', hold: true },
], POUNCE_MS)

type HoundSmoothMode = 'old' | '1028'
let mode: HoundSmoothMode = 'old'
let saved: { lunge?: BossAttackTimeline; pounce?: BossAttackTimeline } | null = null
export function houndSmoothMode(): HoundSmoothMode { return mode }
export function setHoundSmooth(raw: string | null): void {
  mode = import.meta.env.DEV && raw === '1028' ? '1028' : 'old'
  const tls = BOSS_ATTACK_TIMELINES['dream-hound']
  if (!tls) return
  if (mode === '1028') {
    if (!saved) saved = { lunge: tls.houndLunge, pounce: tls.houndPounce }
    tls.houndLunge = HOUND_LUNGE_SMOOTH_1028
    tls.houndPounce = HOUND_POUNCE_SMOOTH_1028
  } else if (saved) {
    if (saved.lunge) tls.houndLunge = saved.lunge
    if (saved.pounce) tls.houndPounce = saved.pounce
    saved = null
  }
}
